
import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_announcements_admin = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/admin`,
        method: "GET",
        credentials: "include"
    });
};

export const create_new_announcement = async (announcement_data) => {
    if (!announcement_data) return { error: "No announcement data provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(announcement_data),
        credentials: "include"
    });
};

export const update_announcement_by_id = async (announcement_id, announcement_data) => {
    if (!announcement_id) return { error: "No announcement id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/id/${announcement_id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(announcement_data),
        credentials: "include"
    });
};

export const delete_announcement_by_id = async (announcement_id) => {
    if (!announcement_id) return { error: "No announcement id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/id/${announcement_id}`,
        method: "DELETE",
        credentials: "include"
    });
};

export const fetch_announcement_by_id = async (announcement_id) => {
    if (!announcement_id) return { error: "No announcement id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/id/${announcement_id}`,
        method: "GET",
        credentials: "include"
    });
};

export const duplicate_announcement = async (announcement_data) => {
    if (!announcement_data) return { error: "No announcement data provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/duplicate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(announcement_data),
        credentials: "include"
    });
};

export const fetch_ongoing_announcements = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/ongoing`,
        method: "GET",
        credentials: "include"
    });
};

export const fetch_child_announcements = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/child`,
        method: "GET",
        credentials: "include"
    });
};

export const fetch_all_announcements = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/announcements/`,
        method: "GET",
        credentials: "include"
    });
};
